/**
 * Stytch SMS OTP Creation Hook
 *
 * This hook provides functionality for creating TOTP (Time-based One-Time Password)
 * authentication using the Stytch B2B headless client.
 */
import { useCallback } from 'react';
import { getStytchClient } from '../../../../adapters/react/client/headless-client';
export function useStytchUpdateOrganization() {
    return useCallback(async (data) => {
        const stytch = getStytchClient();
        if (!stytch) {
            return {
                success: false,
                error: 'Stytch client not ready',
                data: null,
            };
        }
        try {
            const result = await stytch.organization.update({
                organization_name: data.organizationName,
                organization_slug: data.organizationSlug,
                organization_logo_url: data.organizationLogoUrl,
                email_invites: data.emailInvites,
                email_jit_provisioning: data.emailJitProvisioning,
                email_allowed_domains: data.emailAllowedDomains,
                sso_default_connection_id: data.ssoDefaultConnectionId,
                sso_jit_provisioning: data.ssoJitProvisioning,
                sso_jit_provisioning_allowed_connections: data.ssoJitProvisioningAllowedConnections,
                auth_methods: data.authMethods,
                allowed_auth_methods: data.allowedAuthMethods,
                mfa_methods: data.mfaMethods,
                allowed_mfa_methods: data.allowedMfaMethods,
                mfa_policy: data.mfaPolicy,
                rbac_email_implicit_role_assignments: data.rbacEmailImplicitRoleAssignments,
                oauth_tenant_jit_provisioning: data.oauthTenantJitProvisioning,
                allowed_oauth_tenants: data.allowedOAuthTenants,
            });
            return {
                success: true,
                requestId: result.request_id,
                statusCode: result.status_code,
                organization: result.organization,
            };
        }
        catch (error) {
            const err = error;
            return {
                success: false,
                error: err.error_message || err.message || 'Failed to update organization',
                data: error,
            };
        }
    }, []);
}
